type Row = Record<string, unknown>;
/** Literal or essence-tag modifier, shared by ability and weapon extra fragments. */
export function extraFragmentMod(raw: unknown, caster: Row, value: (row: Row, key: string) => unknown):
    { mod: number } | { missingEssence: string } | null {
    if (raw == null || raw === '') return { mod: 0 };
    while (Array.isArray(raw)) raw = raw[0];
    const text = String(raw ?? '').trim();
    if (/^[+-]?\d+$/.test(text)) return { mod: parseInt(text, 10) };
    const tag = /^\[(body|mind|soul|spirit|fortune)\]$/.exec(text)?.[1];
    if (!tag) return null;
    let essence = value(caster, tag);
    while (Array.isArray(essence)) essence = essence[0];
    if (essence == null || essence === '') return { missingEssence: tag };
    if ((typeof essence !== 'number' && typeof essence !== 'string')
        || typeof essence === 'string' && !/^-?\d+$/.test(essence)) return null;
    const mod = Number(essence);
    return Number.isSafeInteger(mod) ? { mod } : null;
}
